/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";
import {DB_Patient} from "@app/app-shared/patient";
import {AutoComplete} from "./AutoComplete";
import {ICONS} from "@res/icons";

type Props = {
	patients?: DB_Patient[]
	onSelected: (selectedPatients: string[]) => void
	selectedPatients: string[]
	onSearch?: (text: string) => void
}

export class PatientSearch
	extends React.Component<Props> {

	render() {
		const patients = this.props.patients;
		if (!patients)
			return "...";
		const filtered = patients.filter(it => !this.props.selectedPatients.includes(it._id));
		return <div
			className={"ll_h_c"}
			style={{width: 231, border: "1px solid rgb(201, 203, 206)", borderRadius: 6, zIndex: 9999}}
		>
			<div style={{flex: 1}}>
				<AutoComplete<DB_Patient>
					id={"patient_search"}
					options={filtered}
					labelResolver={patient => `${patient.name} - ${patient.unitId}`}
					onSelected={patient => {
						const selectedPatients = this.props.selectedPatients;
						selectedPatients.push(patient._id);
						this.props.onSelected(selectedPatients);
					}}
					placeholder={"Search by customer"}
					width={219}
					inputStyle={{
						paddingLeft: 6,
						outline: "none"
					}}
					onSearch={(text) => this.props.onSearch?.(text)}
				/>
			</div>
			<div style={{position: "relative", right: 10}}>
				{ICONS.search("#c9cbce", 14)}
			</div>
		</div>;
	}
}
